// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1qnIp","right":"right__3zFuA","tips":"tips__S0QnZ","danger":"danger__1tXFi","success":"success__1Zqr0","warning":"warning__2IU0x","primary":"primary__16bqv","info":"info__1XAoh","bottom":"bottom__1Sssf","top":"top__qTcA4","arrow":"arrow__29yIH","left":"left__1-RIN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ControlTips/styles.scss
// module id = 2123
// module chunks = 1